import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import ScrollLock from '../utils/ScrollLock';
import rimg from 'rimg-shopify';
import SVG from './SVG.jsx';

rimg.init();

export default class Drawer extends React.PureComponent {
  constructor(props) {
    super();

    this.contentRef = React.createRef();
    this.lockedToEl = this.contentRef.current;
  }

  componentDidUpdate() {
    if (this.props.open) {
      if (this.contentRef.current.querySelector('.ff-form')) {
        ScrollLock.lock(this.contentRef.current.querySelector('.ff-form'))
        this.lockedToEl = this.contentRef.current.querySelector('.ff-form');
      } else {
        ScrollLock.lock(this.contentRef.current)
        this.lockedToEl = this.contentRef.current;
      }
    } else {
      if (this.lockedToEl) {
        ScrollLock.unlock(this.lockedToEl)
      } else {
        ScrollLock.unlockAll();
      }
    }
  }

  componentWillUnmount() {
    if (this.lockedToEl) {
      ScrollLock.unlock(this.lockedToEl)
    } else {
      ScrollLock.unlockAll();
    }
  }

  render() {
    return ReactDOM.createPortal(
      <CSSTransition in={this.props.open}
        addEndListener={(node, done) => { node.addEventListener("transitionend", done, false); rimg.watch(node) }}
        classNames="drawer"
        mountOnEnter={this.props.mountOnEnter}
        unmountOnExit={this.props.unmountOnExit}>
        <div className="react-drawer-wrap">
          <div className="drawer-overlay" onClick={(e) => { this.props._close() }}></div>
          <div className={`${this.props.className || ''} drawer`}>
            <button className="drawer-close" aria-label="Close" onClick={(e) => { e.preventDefault(); this.props._close() }}>
              <SVG icon="close" />
            </button>
            <div className={this.props.contentClass ? `drawer-content ${this.props.contentClass}` : 'drawer-content'} ref={this.contentRef}>
              {this.props.heading ? <div className="header-wrap"><h1 className="title">{this.props.heading}</h1></div> : null}
              {this.props.children}
              {this.props.content ? <div className="rte text-content" dangerouslySetInnerHTML={{ __html: this.props.content }} /> : null}
            </div>
          </div>
        </div>
      </CSSTransition>, document.body)
  }
}